var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backgroundPage",staticStyle:{"height":"100%"}},[_c('v-main',{staticStyle:{"height":"100%"}},[_c('v-container',{staticClass:"d-flex justify-center",staticStyle:{"height":"100%"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }